import React, { Fragment } from 'react';
import { FileContainer } from '../File/FileContainer.js';
import 'tslib';
import 'clsx';
import './../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../util/Visible/Visible.js';

var FilesList = function (_a) {
    var files = _a.files, deleteFile = _a.deleteFile, withDivider = _a.withDivider, hasFileProcessing = _a.hasFileProcessing;
    return (React.createElement("div", { className: 'c-uploader__files-list' }, files.map(function (file, index) {
        var handleDeleteFile = function () { return function () {
            deleteFile(file.id);
        }; };
        return (React.createElement(Fragment, { key: index },
            React.createElement(FileContainer, { key: file.id, file: file, hasFileProcessing: hasFileProcessing, deleteFile: handleDeleteFile() }),
            React.createElement(Visible, { when: withDivider && index !== files.length - 1 },
                React.createElement("div", { "data-testid": 'file-divider', className: 'c-uploader__file-divider' }))));
    })));
};

export { FilesList as default };
//# sourceMappingURL=FilesList.js.map
